module.exports = __webpack_public_path__ + "html/configuration.template.html";